import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@fgb/core';
import { AuctionPanelModule } from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-panel';
import { MarketplaceListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-list-item';
import { LottosListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-panel';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-list-item';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';

function MixedLoyaltyItemComponent_fgbcl_auction_panel_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-auction-panel", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("auctionItem", ctx_r0.item.data)("ignoreLink", ctx_r0.ignoreLink);
} }
function MixedLoyaltyItemComponent_fgbcl_marketplace_list_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-marketplace-list-item", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("marketplaceItem", ctx_r1.item.data)("ignoreLink", ctx_r1.ignoreLink);
} }
function MixedLoyaltyItemComponent_fgbcl_lottos_list_item_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-lottos-list-item", 6);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("lottoItem", ctx_r2.item.data)("ignoreLink", ctx_r2.ignoreLink);
} }
class MixedLoyaltyItemComponent {
    constructor() {
        this.ignoreLink = false;
    }
    ngOnInit() { }
}
MixedLoyaltyItemComponent.ɵfac = function MixedLoyaltyItemComponent_Factory(t) { return new (t || MixedLoyaltyItemComponent)(); };
MixedLoyaltyItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MixedLoyaltyItemComponent, selectors: [["fgbcl-mixed-loyalty-item"]], inputs: { ignoreLink: "ignoreLink", item: "item" }, decls: 4, vars: 4, consts: [[3, "ngSwitch"], [3, "auctionItem", "ignoreLink", 4, "ngSwitchCase"], [3, "marketplaceItem", "ignoreLink", 4, "ngSwitchCase"], [3, "lottoItem", "ignoreLink", 4, "ngSwitchCase"], [3, "auctionItem", "ignoreLink"], [3, "marketplaceItem", "ignoreLink"], [3, "lottoItem", "ignoreLink"]], template: function MixedLoyaltyItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, MixedLoyaltyItemComponent_fgbcl_auction_panel_1_Template, 1, 2, "fgbcl-auction-panel", 1);
        ɵngcc0.ɵɵtemplate(2, MixedLoyaltyItemComponent_fgbcl_marketplace_list_item_2_Template, 1, 2, "fgbcl-marketplace-list-item", 2);
        ɵngcc0.ɵɵtemplate(3, MixedLoyaltyItemComponent_fgbcl_lottos_list_item_3_Template, 1, 2, "fgbcl-lottos-list-item", 3);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.item.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "auction");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "marketplace");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "lotto");
    } }, directives: [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc2.AuctionPanelComponent, ɵngcc3.MarketplaceListItemComponent, ɵngcc4.LottosListItemComponent], styles: [""] });
MixedLoyaltyItemComponent.ctorParameters = () => [];
MixedLoyaltyItemComponent.propDecorators = {
    item: [{ type: Input }],
    ignoreLink: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MixedLoyaltyItemComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-mixed-loyalty-item',
                template: "<ng-container [ngSwitch]=\"item.type\">\r\n  <fgbcl-auction-panel *ngSwitchCase=\"'auction'\" [auctionItem]=\"item.data\" [ignoreLink]=\"ignoreLink\"></fgbcl-auction-panel>\r\n  <fgbcl-marketplace-list-item\r\n    *ngSwitchCase=\"'marketplace'\"\r\n    [marketplaceItem]=\"item.data\"\r\n    [ignoreLink]=\"ignoreLink\"\r\n  ></fgbcl-marketplace-list-item>\r\n  <fgbcl-lottos-list-item *ngSwitchCase=\"'lotto'\" [lottoItem]=\"item.data\" [ignoreLink]=\"ignoreLink\"></fgbcl-lottos-list-item>\r\n</ng-container>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { ignoreLink: [{
            type: Input
        }], item: [{
            type: Input
        }] }); })();

class MixedLoyaltyItemModule {
}
MixedLoyaltyItemModule.ɵfac = function MixedLoyaltyItemModule_Factory(t) { return new (t || MixedLoyaltyItemModule)(); };
MixedLoyaltyItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MixedLoyaltyItemModule });
MixedLoyaltyItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, AuctionPanelModule, MarketplaceListItemModule, LottosListItemModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MixedLoyaltyItemModule, { declarations: function () { return [MixedLoyaltyItemComponent]; }, imports: function () { return [CommonModule, AuctionPanelModule, MarketplaceListItemModule, LottosListItemModule]; }, exports: function () { return [MixedLoyaltyItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MixedLoyaltyItemModule, [{
        type: NgModule,
        args: [{
                declarations: [MixedLoyaltyItemComponent],
                imports: [CommonModule, AuctionPanelModule, MarketplaceListItemModule, LottosListItemModule],
                exports: [MixedLoyaltyItemComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MixedLoyaltyItemComponent, MixedLoyaltyItemModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-mixed-loyalty-mixed-loyalty-item.js.map